import styled from 'styled-components';

export const StyledSection = styled.div`
  padding: 18px 17px;
  background-color: rgba(0, 0, 0, 0.6);
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  transition: opacity 1s ease 1s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }

  &:active {
    background-color: #000;
  }

  &.notificationDeleting {
    opacity: 0.1;
  }
`;

export const StyledCancel = styled.div`
  margin-left: 16px;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  text-decoration: underline;
  position: relative;
  cursor: pointer;
  align-self: center;
`;
